"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.RadioGroup = void 0;
var react_1 = __importDefault(require("react"));
var ElementTag_1 = __importDefault(require("../internal/ElementTag"));
var RadioContext_1 = require("./RadioContext");
var RadioGroup = function (_a) {
    var name = _a.name, onChange = _a.onChange, onChanging = _a.onChanging, selectedValue = _a.selectedValue, className = _a.className, rest = __rest(_a, ["name", "onChange", "onChanging", "selectedValue", "className"]);
    return (react_1["default"].createElement(RadioContext_1.RadioContext.Provider, { value: RadioContext_1.useInitializeContext({
            name: name,
            onChange: onChange,
            onChanging: onChanging,
            selectedValue: selectedValue
        }) },
        react_1["default"].createElement(ElementTag_1["default"], __assign({ className: ['radio-group', className] }, rest))));
};
exports.RadioGroup = RadioGroup;
//# sourceMappingURL=RadioGroup.js.map